// Components
import WebsitePreview from '../WebsitePreview';
import WebsitePreviewSticky from '../WebsitePreviewSticky';
import WeddingPartyMembers from '../entities/WeddingPartyMembers';
import Faqs from '../entities/Faqs';
import Pois from '../entities/Pois';
import Travel from '../entities/Travel/Travel';
import RegistryContainer from '../entities/RegistryContainer';
import Photos from '../entities/Photos';
import Homepage from '../entities/Homepage';
import Events from '../entities/Events';
import RsvpContainer from '../entities/Rsvp/RsvpContainer';

export const EDIT_PAGE_COMPONENTS = {
  WEDDING_PARTY: {
    page: WeddingPartyMembers,
    preview: WebsitePreview,
  },
  POI: {
    page: Pois,
    preview: WebsitePreview,
  },
  FAQ: {
    page: Faqs,
    preview: WebsitePreview,
  },
  TRAVEL: {
    page: Travel,
    preview: WebsitePreview,
  },
  REGISTRY: {
    page: RegistryContainer,
    preview: undefined,
  },
  PHOTO: {
    page: Photos,
    preview: WebsitePreview,
  },
  HOME: {
    page: Homepage,
    preview: WebsitePreviewSticky,
  },
  EVENT: {
    page: Events,
    preview: WebsitePreviewSticky,
  },
  RSVP: {
    page: RsvpContainer,
    preview: undefined,
  },
};

export const getDashboardPreviewByKey = pageKey => {
  if (pageKey === 'HOME' || pageKey === 'EVENT') {
    return WebsitePreviewSticky;
  }

  return WebsitePreview;
};
